import { useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { addAllBoard, searchCard, setDateRange } from "../../../redux/SearchSlice";
import { setAllGroupUser } from "../../../redux/TaskGroupingSlice";
import { useTeams } from "../../../reactQuery/teams";
import { useCustomSearchParams } from "../../../hooks/useCustomSearchParams";
import {
  getFlattenedGroupingUsers,
} from "../utils/myTaskUtils";

export function useWorklogFiltersState() {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { teams } = useTeams();
  const checkedList = useSelector((state) => state.search.boardSearch);
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );
  const [isVisible, setIsVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [, setSearchParam] = useCustomSearchParams("txt");
  const userParam = searchParams.get("uid");
  const boardParam = searchParams.get("board");

  const debouncedSearch = useRef(
    _.debounce((value) => {
      dispatch(searchCard(value));
      setSearchParam("txt", value);
    }, 300)
  ).current;

  useEffect(() => {
    if (userParam || boardParam) {
      setIsVisible(true);
    }
  }, [boardParam, userParam]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
      dispatch(setAllGroupUser([]));
      dispatch(addAllBoard([]));
      dispatch(setDateRange(null));
    };
  }, [debouncedSearch, dispatch]);
  const removeSearchParams = useCallback(
    (paramsToRemove) => {
      const nextSearchParams = new URLSearchParams(searchParams);
      paramsToRemove.forEach((param) => {
        nextSearchParams.delete(param);
      });
      setSearchParams(nextSearchParams);
    },
    [searchParams, setSearchParams]
  );

  const clearFilters = useCallback(() => {
    dispatch(addAllBoard([]));
    dispatch(setAllGroupUser([]));
    removeSearchParams(["board", "uid"]);
    setIsVisible(false);
  }, [dispatch, removeSearchParams]);

  const handleChange = useCallback(
    (event) => {
      const value = event.target.value.trimStart();
      setInputValue(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  const handleVisibilityChange = useCallback(
    (value) => {
      setIsVisible(value);
      if (!value) {
        clearFilters();
      }
    },
    [clearFilters]
  );

  return {
    checkedList,
    clearFilters,
    groupingUsers: getFlattenedGroupingUsers(groupingUser),
    handleChange,
    handleVisibilityChange,
    inputValue,
    isVisible,
    teams,
  };
}
